var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4285 0.57366C5.1268 0.57366 0 5.70035 0 12.0019C0 18.3039 5.1268 23.4309 11.4285 23.4309C17.7301 23.4309 22.8567 18.3038 22.8567 12.0019C22.8567 5.70035 17.7301 0.57366 11.4285 0.57366ZM11.4285 21.7926C6.03015 21.7926 1.63827 17.4005 1.63827 12.0019C1.63827 6.60369 6.03015 2.21193 11.4285 2.21193C16.8266 2.21193 21.2184 6.60369 21.2184 12.0019C21.2184 17.4005 16.8266 21.7926 11.4285 21.7926Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    d: "M17.3058 11.8093H11.9352V5.93856C11.9352 5.48617 11.5685 5.11942 11.116 5.11942C10.6636 5.11942 10.2969 5.48617 10.2969 5.93856V12.6283C10.2969 13.0808 10.6636 13.4475 11.116 13.4475H17.3058C17.7583 13.4475 18.1249 13.0808 18.1249 12.6283C18.1249 12.176 17.7582 11.8093 17.3058 11.8093Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.540a58037ad7cca4d4ea15e5fa8ec1a3.svg";
export { ForwardRef as ReactComponent };